import { z } from 'zod';

/** Company id in a request or response body. */
export const companyId = z.number().or(z.string()).nullish();

/** Company id in a query string. */
export const companyIdQueryParams = z.number().or(z.string()).optional();

export const DataResponseSchema = <T extends z.ZodType>(itemSchema: T) =>
  z.object({
    items: z.array(itemSchema),
    additional: z.any().nullable().optional(),
    itemsPerPage: z.number().nullable().optional(),
    totalItems: z.number().nullable().optional(),
    message: z.string().nullable().optional(),
    ordering: z.string().nullable().optional(),
    pageNumber: z.number().nullable().optional(),
  });
